import { styled } from '@slal/ui';
import { Link } from 'react-router';

export const StyledLink = styled(Link)`
    color: ${({ theme }) => theme.colors.blue__secondary__80};
    svg {
        vertical-align: middle;
        color: ${({ theme }) => theme.colors.blue__secondary__80};
        margin-left: 2px;
    }
`;
